import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Stack, Typography, Skeleton } from "@mui/material";
import useAxios from "../hooks/useAxios";
import VideoThumbnail from "../components/VideoThumbnail";
import VideoThumbnailSkeleton from "../components/Skeletons/VideoThumbnailSkeleton";
import { useSearchParams } from "react-router-dom/dist";
import { filteringOptions } from "../components/FilteringChips";

export default function VideosFeed() {
  const [videosArray, setVideoArray] = useState([]);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const axios = useAxios();
  const { pathname } = useLocation();
  const id = pathname.charAt(pathname.length - 1);
  const [searchParams] = useSearchParams();
  const searchTerm = searchParams.get("search");
  const [search, setSearch] = useState(searchTerm);

  useEffect(() => {
    if (search !== searchTerm) {
      window.location.reload();
      setSearch(searchTerm);
    }
  }, [search, searchTerm]);

  useEffect(() => {
    const fetchVideos = async () => {
      setLoading(true);
      const searchTerm = searchParams.get("search");
      const order = searchParams.get("order");
      const isRecommendation = +order === 3;
      try {
        const url = isRecommendation
          ? `recommend/-1?limit=30`
          : searchTerm
          ? `search?text=${searchTerm}`
          : +id === 0 && order
          ? `category/0/content?order=${order}&limit=0`
          : "category/" + id + "/content?limit=0";
        const response = await axios.get(url);
        setTitle(
          searchTerm
            ? searchTerm
            : isRecommendation
            ? "مقترح لك"
            : response.data.title
        );
        setVideoArray(
          searchTerm || isRecommendation
            ? response.data
            : response.data.contents
        );
      } catch (error) {}
      setLoading(false);
    };
    fetchVideos();
  }, [id, axios, searchParams]);

  const videoThumbs = videosArray?.map((video) => {
    return (
      <VideoThumbnail
        key={Math.random()}
        src={video?.thumbnail}
        duration={video?.details?.duration}
        title={video?.title?.ar}
        videoId={video?.id}
        catagoryId={video?.category_id}
        rating={video?.rate}
      />
    );
  });

  return (
    <Stack flexDirection="column" gap={3} px={2} mt={3}>
      {title ? (
        <Typography variant="h4">
          {+id === 0
            ? filteringOptions.find(
                (option) => option.value === +searchParams.get("order")
              )?.label
            : title}
        </Typography>
      ) : (
        <Skeleton width={150} height={20} />
      )}

      <Stack
        flexDirection="row"
        flexWrap="wrap"
        gap={{ xs: 5, sm: 1.5 }}
        boxShadow={0}
      >
        {videoThumbs}
        {videosArray?.length <= 0 &&
          loading &&
          [...Array(5)].map(() => (
            <VideoThumbnailSkeleton key={Math.random()} />
          ))}
        {videosArray?.length <= 0 && !loading && (
          <Typography>لا توجد مقاطع فيديو</Typography>
        )}
      </Stack>
    </Stack>
  );
}
